import { PatientContext } from '@/components/Patient/PatientContext';
import { getConsultLoggingInfo as getConsultLoggingInfoUtil } from '@/components/PatientPageV2/utils/getConsultLoggingInfo';
import { isDoctor } from '@/data/service/authService';
import { useCanUserChargeConsult } from '@/hooks/consult/useCanUserChargeConsult';
import type { ConsultationModel } from '@/types';
import { useCallback, useContext } from 'react';

export const useConsultLoggingInfo = ({
  consult,
  isConcessionPatient,
}: {
  consult?: ConsultationModel;
  isConcessionPatient: boolean;
}) => {
  const isDoc = isDoctor();
  const { canUserChargeConsult } = useCanUserChargeConsult({
    consultationType: consult?.consult_type,
    doctorId: consult?.doctor_id ?? undefined,
  });
  const { patientId } = useContext(PatientContext);

  const getConsultLoggingInfo = useCallback(
    (extraProperties?: Record<string, string | number | boolean>) => {
      return getConsultLoggingInfoUtil({
        isDoc,
        canUserChargeConsult,
        patientId,
        isConcessionPatient,
        consult,
        extraProperties,
      });
    },
    [canUserChargeConsult, consult, isConcessionPatient, isDoc, patientId],
  );

  return getConsultLoggingInfo;
};
